
import { ActionTypes, MutationTypes, useStore } from "@/store";
import { defineComponent } from "vue";
import { AmazonsEngine } from './AmazonsEngine';
import { Move } from "./Move";

const HistoryList = defineComponent({
  props: {},
  data() {
    return {
      store: useStore(),
      hover: -1,
      game: new AmazonsEngine(useStore())
    };
  },
  methods: {
    handleHistoryMoveItemClicked(ev: Event, index: number) {
      this.store.dispatch(ActionTypes.JUMP_TO_MOVE_NUMBER, index);
    },
    stepToPreviousMove() {
      this.game.backMove();
    },

    stepToNextMove() {
      this.game.nextMove();
    },

    loadGameFromClipboard() {
      navigator.clipboard.readText().then((text) => {
        this.game.playGameFromString(text);
      });
    },
  },
  computed: {
    moves(): Move[] {
      return this.store.getters.moves;
    },
    moveListStyle(): object {
      return {
        "max-height": this.store.getters.boardLength -50 + "px",
      };
    },
  },
});
export default HistoryList;
